import { Output } from "../output";
import { Group } from "./group";
import { Model } from "./model";
export class Scene extends Output {
    constructor(synth, props) {
        super(synth, props);
        this.children = [];
        this._camera = synth._camera;
        this.synth.scenes.push(this);
    }
    add(...models) {
        models.forEach(model => {
            if (model instanceof Group) {
                model.children.forEach(child => this.add(child));
                return;
            }
            if (!this.children.includes(model)) {
                if (model instanceof Model) {
                    model.camera(this._camera);
                }
                model.out(this);
                this.children.push(model);
            }
        });
        this.children.forEach((child, index) => {
            child.autoClear(index === 0);
        });
        return this;
    }
    camera(camera = this.synth._camera) {
        this._camera = camera;
        this.children.forEach(child => child instanceof Model && child.camera(camera));
        return this;
    }
    update() {
        if (!this.children?.length)
            return this;
        this.children.forEach((child, index) => {
            child.autoClear(index === 0);
            child.forceUpdate();
        });
        return this;
    }
    clear() {
        this.children.forEach(child => {
            child.clear();
            //child.texture.clear()
        });
        this.children = [];
        return this;
    }
}
